import { ExpandableCell } from '@revolut-internal/ui-kit'

import { CustomPlaceholder as Placeholder } from 'components/Placeholder/Placeholder'
import { FCWithChildren } from 'types'

type ErrorMessageProps = {
  message?: string
}

export const ErrorMessage: FCWithChildren<ErrorMessageProps> = ({
  message,
  children,
}) => {
  return (
    <Placeholder
      icon="CrossCircle"
      title="Something went wrong"
      description={
        <ExpandableCell>
          <ExpandableCell.Title color="red">
            {message ?? 'Unknown error'}
          </ExpandableCell.Title>
          <ExpandableCell.Note color="red">
            <pre>{children}</pre>
          </ExpandableCell.Note>
        </ExpandableCell>
      }
    />
  )
}
